import { useState } from "react"
import './ConfigBudgetForm.css'

/* Credit cards img */
import Visa from "../../../../shared/img/creditCard/visa.png"
import Amex from "../../../../shared/img/creditCard/amex.png"
import Mastercard from "../../../../shared/img/creditCard/mastercard.png"
import Hipercard from "../../../../shared/img/creditCard/hipercard.png"
import Elo from "../../../../shared/img/creditCard/elo.png"
import Dinersclub from "../../../../shared/img/creditCard/dinersclub.png"

/* form */
import Input from "../../../../shared/components/form/input"
import Radio from '../../../../shared/components/form/Radio'
import Checkbox from '../../../../shared/components/form/checkbox'
import FormLayout from "../../../../shared/components/FormLayout/FormLayout"
import FormSection from "../../../../shared/components/FormLayout/FormSection"
import Button from "../../../../shared/components/Button/Button"

const PAYMENT_CARDS = [
    { name: 'visa', img: Visa },
    { name: 'amex', img: Amex },
    { name: 'mastercard', img: Mastercard },
    { name: 'hipercard', img: Hipercard },
    { name: 'dinersclub', img: Dinersclub },
    { name: 'elo', img: Elo },
]

function ConfigBudgetForm({ dataConfig, handleOnSubmit, title, btCancelAction }) {
    const [config, setConfig] = useState(dataConfig || {})

    function handleChange(e) {
        setConfig({ ...config, [e.target.name]: e.target.value })
    }

    function handleChangeCheckbox(name, value) {
        setConfig({ ...config, [name]: value })
    }

    const handleChangeRadio = (name, value) => {
        setConfig({ ...config, [name]: value })
    }

    async function submit(e) {
        e.preventDefault()
        handleOnSubmit(config)
    }

    return (
        <FormLayout
            title={title || 'Configuração Padrão de Proposta'}
            onSubmit={submit}
            actions={
                <>
                    <Button variant="save" type="submit">Salvar</Button>
                    {btCancelAction && <Button variant="cancel" onClick={btCancelAction}>Cancelar</Button>}
                </>
            }
        >
            <FormSection label="Prazos">
                <div className="fl-row">
                    <div className="fl-col-mid form-group">
                        <Input
                            text="Validade da proposta"
                            type="text"
                            name="proposalTime"
                            placeholder="digite o texto do campo validade da proposta"
                            handleOnChange={handleChange}
                            value={config.proposalTime || ''}
                        />
                    </div>
                    <div className="fl-col-mid form-group">
                        <Input
                            text="Previsão de entrega"
                            type="text"
                            name="deliveryForecast"
                            placeholder="digite o texto do campo previsão de entrega"
                            handleOnChange={handleChange}
                            value={config.deliveryForecast || ''}
                        />
                    </div>
                </div>
            </FormSection>

            <FormSection label="Meios de Pagamento">
                <div className="fl-row">
                    <div className="fl-col-wide form-group">
                        <Input
                            text="Texto meio de pagamento"
                            type="textarea"
                            name="paymentMethodText"
                            placeholder="digite o texto do campo meio de pagamento"
                            handleOnChange={handleChange}
                            value={config.paymentMethodText || ''}
                        />
                    </div>
                </div>
                <div className="cb-card-row">
                    {PAYMENT_CARDS.map((card) => (
                        <Checkbox
                            key={card.name}
                            text={<img className='cb-card-img' src={card.img} alt={card.name} />}
                            name={card.name}
                            handleOnChange={() => handleChangeCheckbox(card.name, !config[card.name])}
                            check={config[card.name]}
                        />
                    ))}
                </div>
            </FormSection>

            <FormSection label="Frete">
                <Radio
                    options={[
                        { value: 'cif', label: 'CIF' },
                        { value: 'fob', label: 'FOB(por conta do cliente)' },
                    ]}
                    name="shipping"
                    value={config.shipping}
                    defaultValue="cif"
                    handleOnChange={handleChangeRadio}
                />
            </FormSection>

            <FormSection label="Observações">
                <div className="fl-row">
                    <div className="fl-col-wide form-group">
                        <Input
                            text="Observações"
                            type="textarea"
                            name="proposalObs"
                            placeholder=""
                            handleOnChange={handleChange}
                            value={config.proposalObs || ''}
                        />
                    </div>
                </div>
            </FormSection>
        </FormLayout>
    )
}

export default ConfigBudgetForm
